import { create } from 'apisauce';

const apiClient = create ({
    baseURL: "https://partnerservice-stage.jesusredeems.com/"
    //  baseURL: "http://localhost:8080" Do not use localhost as Android may not be able connect
});

export default apiClient;